import React from 'react';
import {Container, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import ProgressPieCharts from './ProgressPieCharts';
import ProgressCourses from './ProgressCourses';

const ProfilePage = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="xl" className={classes.container}>
      <Grid container spacing={3}>
        <ProgressCourses />
        <ProgressPieCharts />
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '30px',
  },
}));

export default ProfilePage;
